import axios from 'axios';


const url = '/api/configuration/project-group';

export const getList = ({ q } = {}) => axios.get(url, { params: { q } })
    .then(response => response.data);

export const get = ({ id }) => axios.get(`${url}/${id}`)
    .then(response => response.data);



// WEBPACK FOOTER //
// ../utils/api/configuration/company.js